import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import hexToRgbChannels from '../../assets/js/hexToRgbChannels';
import '../../assets/styles/InfoCard.css';

const SPRING = { type: 'spring', stiffness: 300, damping: 15 };

const InfoCard = React.forwardRef(
  (
    {
      title,
      description,
      icon,
      imageUrl,
      footer,
      href,
      accent,
      className = '',
      ...props
    },
    ref
  ) => {
    const reduced = useReducedMotion() === true;
    const Card = href ? motion.a : motion.article;

    const linkProps = href
      ? {
          href,
          target: '_blank',
          rel: 'noopener noreferrer',
          'aria-label': `${title}`
        }
      : {};

    return (
      <Card
        ref={ref}
        className={`info-card ${footer ? 'has-footer' : ''} ${className}`.trim()}
        style={
          accent
            ? {
                '--info-card-accent': accent,
                '--info-card-accent-rgb': hexToRgbChannels(accent) || undefined
              }
            : undefined
        }
        variants={
          reduced
            ? undefined
            : {
                initial: { scale: 1, y: 0 },
                hover: { scale: 1.03, y: -5, transition: SPRING }
              }
        }
        initial={reduced ? undefined : 'initial'}
        whileHover={reduced ? undefined : 'hover'}
        {...linkProps}
        {...props}
      >
        <div className="info-card__body">
          {footer && icon && (
            <span className="info-card__mark" aria-hidden="true">{icon}</span>
          )}
          <h3 className="info-card__title">{title}</h3>
          {description && <p className="info-card__desc">{description}</p>}
        </div>

        {footer && <div className="info-card__footer">{footer}</div>}

        {!footer && (icon || imageUrl) && (
          <span className="info-card__art" aria-hidden="true">
            {imageUrl ? <img src={imageUrl} alt="" className="info-card__img" /> : icon}
          </span>
        )}
      </Card>
    );
  }
);

InfoCard.displayName = 'InfoCard';

export default InfoCard;
export { InfoCard };
